import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CreateIncidentRequest,
  EditIncidentRequest,
  Incident,
  IncidentDetailsResponse,
  IncidentSearchEvent,
} from 'src/app/features/incidents/incident-models';
import { EnvironmentLoaderService } from './environment-loader.service';
import { PagedResult } from '../models/paging';

@Injectable({
  providedIn: 'root',
})
export default class IncidentService {
  private httpClient = inject(HttpClient);
  private environmentLoaderService = inject(EnvironmentLoaderService);

  apiUrl: string;

  constructor() {
    this.apiUrl = this.environmentLoaderService.config['serviceBaseUrl'] + '/api/v1/admin/incident';
  }

  public getIncidents(searchEvent: IncidentSearchEvent): Observable<PagedResult<Incident>> {
    let parameters = new HttpParams();

    if (searchEvent?.query) {
      parameters = parameters.append('q', searchEvent.query);
    }

    if (searchEvent?.status) {
      parameters = parameters.append('status', searchEvent.status.toString());
    }
    if (searchEvent?.createdBy) {
      parameters = parameters.append('createdBy', searchEvent.createdBy.toString());
    }

    if (searchEvent?.organizationId) {
      parameters = parameters.append('organizationId', searchEvent.organizationId);
    }

    if (searchEvent.paging?.pageIndex) {
      parameters = parameters.append('page', searchEvent.paging.pageIndex);
    }

    if (searchEvent.paging?.pageSize) {
      parameters = parameters.append('pageSize', searchEvent.paging.pageSize);
    }

    if (searchEvent.sorting?.active) {
      parameters = parameters.append('sortby', searchEvent.sorting.active);
    }
    if (searchEvent.sorting?.direction) {
      parameters = parameters.append('sortdirection', searchEvent.sorting.direction);
    }

    return this.httpClient.get<PagedResult<Incident>>(`${this.apiUrl}`, {
      params: parameters,
    });
  }

  public activateIncident(incidentId: number, form: any) {
    return this.httpClient.post(`${this.apiUrl}/${incidentId}/activate`, form);
  }

  public closeIncident(incidentId: number, form: any) {
    return this.httpClient.post(`${this.apiUrl}/${incidentId}/close`, form);
  }

  public createIncident(request: CreateIncidentRequest) {
    return this.httpClient.post(`${this.apiUrl}/`, request);
  }

  public editIncident(request: EditIncidentRequest) {
    return this.httpClient.put(`${this.apiUrl}/`, request);
  }

  public getIncidentDetails(id: number): Observable<IncidentDetailsResponse> {
    return this.httpClient.get<IncidentDetailsResponse>(`${this.apiUrl}/${id}/details`);
  }

  downloadIncidentReport(downloadIncidentReportModel: {
    from: string | null;
    to: string | null;
    organizations: string[] | undefined;
    departments: string[] | undefined;
    locations: string[] | undefined;
  }): Observable<Blob> {
    const url = `${this.apiUrl}/IncidentReport`;
    return this.httpClient.post<Blob>(url, downloadIncidentReportModel, {
      responseType: 'blob' as 'json',
    });
  }
}
